import { Menu } from '@chakra-ui/react';
import { FunctionComponent as FC } from 'react';
import { MdCircle } from 'react-icons/md';
import { pluralize } from '../../utils';
import { MFlex, MIcon, MText, MTooltip } from '../Monetize';

interface NotesDrawerProps {
  isOpen: boolean;
  entity: 'accounts' | 'quotes';
  hasUnSavedNotes: boolean;
  numberOfNotes: number;
  onOpen: () => void;
}

export const NotesDrawerV2Menu: FC<NotesDrawerProps> = ({
  isOpen,
  entity = 'accounts',
  hasUnSavedNotes,
  numberOfNotes,
  onOpen,
}: NotesDrawerProps) => {
  const label = entity === 'accounts' ? 'Account Notes' : 'Quote Notes';

  return (
    <Menu.Item
      key={label}
      value="notes"
      aria-label={label}
      // The host `DataTableActions` menu sets `closeOnSelect={false}`; left
      // open, it stays under the drawer and reappears when the drawer closes.
      closeOnSelect
      onSelect={onOpen}
      color="tPurple.base"
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      w="full"
      data-testid={`data-table-actions-Customize Display`}
    >
      <MText color="inherit">Notes</MText>
      {numberOfNotes > 0 && !hasUnSavedNotes && (
        <MFlex
          justifyContent="center"
          alignItems="center"
          width={4}
          height={4}
          borderRadius={10}
          border="1px solid"
          borderColor="tIndigo.base"
        >
          <NotesTooltip numberOfNotes={numberOfNotes}>
            <MText
              fontWeight="bold"
              color="tIndigo.base"
              mb={-0.5}
              fontSize="xs"
            >
              {numberOfNotes}
            </MText>
          </NotesTooltip>
        </MFlex>
      )}
      {!isOpen && hasUnSavedNotes && (
        <MFlex
          justifyContent="center"
          alignItems="center"
          top="-1.8px"
          right="20px"
          width={3}
          height={3}
          borderRadius={10}
        >
          <MIcon
            as={MdCircle}
            boxSize={3}
            aria-label={label}
            color="tOrange.tangerine"
          />
        </MFlex>
      )}
    </Menu.Item>
  );
};

export const NotesTooltip = ({
  numberOfNotes,
  children,
}: {
  numberOfNotes: number;
  children: React.ReactNode;
}) => {
  return (
    <MTooltip
      label={`${numberOfNotes} ${pluralize('Note', numberOfNotes)}`}
      aria-label="Notes Tooltip"
      placement="top"
    >
      {children}
    </MTooltip>
  );
};
